import React from 'react';
const ChatBotLoader = () => {
    return (React.createElement("div", { className: "chatbot-loader-container" },
        React.createElement("svg", { id: "dots", width: "50px", height: "21px", viewBox: "0 0 132 58", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { stroke: "none", fill: "none" },
                React.createElement("g", { id: "chatbot-loader", fill: "#d9d9d9" },
                    React.createElement("circle", { id: "chatbot-loader-dot1", cx: "25", cy: "30", r: "13" }),
                    React.createElement("circle", { id: "chatbot-loader-dot2", cx: "65", cy: "30", r: "13" }),
                    React.createElement("circle", { id: "chatbot-loader-dot3", cx: "105", cy: "30", r: "13" }))))));
};
export default ChatBotLoader;
